import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";

const Testimonials = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const principalData = await getPrincipalMessage();
        setData(principalData);
      } catch (error) {
        console.log("Data Error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  
  return (
    <>
      {data.length > 0 && (
            <div className="message-container">
              <div className="messagebox">
                <div className="messagedesc">
                  <div className="maintitle">
                    <h3>{data[0].category}'s Message</h3>
                  </div>
                  <div className="msginfo">
                    <div dangerouslySetInnerHTML={{ __html: data[0].message }} />
                  </div>
                </div>
                <div className="messageboximg">
                  <p>
                    {data[0].name} <span> {data[0].category}</span>{" "}
                  </p>
                </div>
              </div>

              <div className="messageimg">
                <div className="testimonialimg">
                 <LazyLoad> <img
                    src={`https://webapi.entab.info/api/image/${data[0].attachments}`}
                    alt="Mercy Memorial School, Kanpur"
                    className="img-fluid"
                  /></LazyLoad>
                </div>
                <div className="mainbtn button">
                  <Link to="/PrincipalMessage">READ MORE</Link>
                </div>
              </div>
            </div>
          )}
          {data.length === 0 &&  (
            <div className="message-container">
              <div className="messagebox">
                <div className="messagedesc">
                  <div className="maintitle">
                    <h3>Principal's Message</h3>
                  </div>
                  <p><b><i>An investment in knowledge pays the best interest." – Benjamin Franklin</i></b></p>
               <p>A warm welcome to Mercy Memorial School (MMS).</p> 
             <p>At MMS, we firmly believe that education is the foundation on which the future of the individuals and society is built. We are relentless in our pursuit of excellence because we understand the profound impact it can have on the lives of young people, their families and the wider community. We are committed to providing an environment where students not only thrive academically but also grow into responsible individuals who can contribute meaningfully to society. Our mission at MMS is to offer a well-rounded experience that blends academic excellence with cultural and practical learning. We aim to empower students with the knowledge and skills necessary to take control of their future and access a world of enhanced opportunities.</p>
                </div>
                <div className="mainbtn button">
                  <Link to="/PrincipalMessage">READ MORE <i className="bi bi-arrow-right"></i></Link>
                </div>
                
              </div>

              <div className="messageimg">
                <div className="testimonialimg">
                  <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/principal.png" alt="Mercy Memorial School, Kanpur" className="img-fluid" /></LazyLoad>
                </div>
                <div className="messageboximg">
                  <p>
                  Mrs. Marina cyril <span> Principal</span> 
                  </p>
                </div>
              </div>
            </div>
          )}
    </>
  );
};

export default Testimonials;
